"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M25.224 40.451a14.113 14.113 0 0 1-9.108-10.413l-.035-.156H4.323a.616.616 0 0 1-.539-.312.6.6 0 0 1 0-.617L16.438 6.806a.62.62 0 0 1 1.076 0l4.717 8.258.178-.113a13.407 13.407 0 0 1 3.614-1.663 14.283 14.283 0 1 1-.8 27.166zM19.18 30.136a11.3 11.3 0 1 0 4.676-12.615l-.158.1 6.473 11.33a.622.622 0 0 1-.537.928H19.106z" })
);

